/**
 * Product Waitlist / Back-In-Stock popup trigger handler
 */
(function () {
  'use strict';

  if (window.__arzopaWaitlistHandlerInitialized) return;
  window.__arzopaWaitlistHandlerInitialized = true;

  /**
   * Checks whether the given trigger link is targeted for Hoppy Popups.
   * Supports:
   *  - 'hoppy', '#hoppy'
   *  - 'hoppy-<id>', '#hoppy-<id>'
   *  - 'futureblink-<id>', '#futureblink-<id>'
   *  - Standard UUID format (with or without #) e.g. 8b5d12af-df74-4ac8-b06b-0eaf9006709a
   */
  function isHoppyTrigger(link) {
    if (!link) return false;
    var s = link.trim().toLowerCase();
    if (s === 'hoppy' || s === '#hoppy') return true;
    if (s.startsWith('hoppy-') || s.startsWith('#hoppy-') || s.startsWith('hoppy_') || s.startsWith('#hoppy_') || s.startsWith('hoppy:') || s.startsWith('#hoppy:')) return true;
    if (s.startsWith('futureblink-') || s.startsWith('#futureblink-') || s.startsWith('futureblink_') || s.startsWith('#futureblink_')) return true;
    if (/^#?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(link.trim())) return true;
    return false;
  }

  /**
   * Extracts the raw Hoppy popup UUID from the trigger link if present.
   */
  function extractHoppyId(link) {
    if (!link) return '';
    var s = link.trim();
    if (s.toLowerCase() === 'hoppy' || s.toLowerCase() === '#hoppy') return '';
    return s.replace(/^#?(hoppy|futureblink)[-_:]?/i, '').replace(/^#/, '').trim();
  }

  /**
   * Triggers the Hoppy Back-in-Stock / Email Collection popup.
   * @param {string} targetId Optional specific popup UUID.
   * @param {string} currentProductId Optional Shopify Product ID for smart matching.
   * @returns {boolean} Whether the popup was successfully shown.
   */
  function triggerHoppyPopup(targetId, currentProductId) {
    var popups = window.emailCollectionBarData?.emailPopups || [];
    var hoppyData = null;

    if (targetId) {
      hoppyData = popups.find(function (p) {
        return p.id === targetId || p._id === targetId;
      });
    } else {
      if (currentProductId) {
        hoppyData = popups.find(function (p) {
          return p.placement?.pages?.some(function (page) {
            return page.id && String(page.id).endsWith('/' + currentProductId);
          });
        });
      }

      if (!hoppyData) {
        hoppyData = popups.find(function (p) {
          return /stock|waitlist|notify/i.test(p.name || '');
        });
      }

      if (!hoppyData && popups.length > 0) {
        hoppyData = popups[0];
      }
    }

    var activeId = targetId || hoppyData?.id || hoppyData?._id;
    if (!activeId && !hoppyData) {
      return false;
    }

    function findPopupElements() {
      var p = null;
      var o = null;
      if (activeId) {
        p = document.getElementById('futureblink-email-popup-' + activeId) ||
            document.querySelector('[futureblink-email-popups-bar="' + activeId + '"]');
        o = document.getElementById('futureblink-email-popup-overlay-' + activeId);
      }
      if (!p && hoppyData?.id) {
        p = document.getElementById('futureblink-email-popup-' + hoppyData.id);
        o = document.getElementById('futureblink-email-popup-overlay-' + hoppyData.id);
      }
      if (!p && hoppyData?._id) {
        p = document.getElementById('futureblink-email-popup-' + hoppyData._id);
        o = document.getElementById('futureblink-email-popup-overlay-' + hoppyData._id);
      }
      if (!p) {
        p = document.querySelector('.futureblink-EmailCollecttionBar-popup') ||
            document.querySelector('[futureblink-email-popups-bar]');
      }
      if (!o) {
        o = document.querySelector('[id^="futureblink-email-popup-overlay-"]') ||
            document.getElementById('futureblink-email-popup-overlay');
      }
      return { popup: p, overlay: o };
    }

    var elements = findPopupElements();
    var popup = elements.popup;
    var overlay = elements.overlay;

    // If DOM element was removed or not yet mounted, initialize directly via window.normalPopup
    if ((!popup || !overlay) && hoppyData && typeof window.normalPopup === 'function') {
      try {
        window.normalPopup(hoppyData);
      } catch (e) {
        console.warn('[Waitlist] Error initializing Hoppy popup via normalPopup:', e);
      }
      elements = findPopupElements();
      popup = elements.popup;
      overlay = elements.overlay;
    }

    if (popup) {
      popup.style.setProperty('display', 'block', 'important');
      if (overlay) {
        overlay.style.setProperty('display', 'block', 'important');
      } else {
        var fallbackOverlay = document.querySelector('[id^="futureblink-email-popup-overlay-"]') ||
                              document.getElementById('futureblink-email-popup-overlay');
        if (fallbackOverlay) fallbackOverlay.style.setProperty('display', 'block', 'important');
      }
      return true;
    } else {
      setTimeout(function () {
        var lateElements = findPopupElements();
        if (lateElements.popup) {
          lateElements.popup.style.setProperty('display', 'block', 'important');
          if (lateElements.overlay) {
            lateElements.overlay.style.setProperty('display', 'block', 'important');
          } else {
            var fb = document.querySelector('[id^="futureblink-email-popup-overlay-"]') ||
                     document.getElementById('futureblink-email-popup-overlay');
            if (fb) fb.style.setProperty('display', 'block', 'important');
          }
        }
      }, 50);
    }

    return false;
  }

  // Expose Hoppy helper functions for other blocks and console testing
    /**
   * Detects whether Hoppy / FutureBlink is installed or active on the page.
   */
  function hasHoppyOnPage() {
    return !!(
      window.emailCollectionBarData?.emailPopups?.length ||
      window.emailCollectionBarData ||
      window.HoppyXHR ||
      window.showEmailCollectionPopup ||
      window.hoppy_interceptor_installed ||
      document.querySelector('script[src*="futureblink"], script[src*="hoppy"]') ||
      document.querySelector('[id*="futureblink"], [futureblink-email-popups-bar], style#hoppy-popup-animations')
    );
  }

  window.hasHoppyOnPage = hasHoppyOnPage;
  window.triggerHoppyPopup = triggerHoppyPopup;
  window.isHoppyTrigger = isHoppyTrigger;
  window.extractHoppyId = extractHoppyId;

  /**
   * Triggers the configured or auto-detected app subscription popup.
   * @param {HTMLElement} btn The button element that was clicked.
   */
  window.triggerWaitlistPopup = function (btn) {
    if (!btn) return;

    const customJs = btn.getAttribute('data-custom-js');
    const popupLink =
      btn.getAttribute('data-waitlist-popup-link') ||
      btn.getAttribute('data-popup-link') ||
      btn.getAttribute('href') ||
      btn.getAttribute('data-trigger-selector') ||
      '';
    const modalId = btn.getAttribute('data-modal-id');
    const productInfo = btn.closest('product-info') || document.querySelector('product-info');
    const productId = btn.getAttribute('data-product-id') || productInfo?.dataset?.productId || '';
    const variantId =
      btn.getAttribute('data-variant-id') ||
      productInfo?.querySelector('[name="id"]')?.value ||
      '';
    const productTitle =
      btn.getAttribute('data-product-title') ||
      document.querySelector('.product__title')?.textContent?.trim() ||
      '';
    const variantTitle = btn.getAttribute('data-variant-title') || '';

    const detail = {
      productId,
      variantId,
      productTitle,
      variantTitle,
      popupLink,
      button: btn,
    };

    // 1. Custom JavaScript trigger execution (if configured)
    if (customJs && customJs.trim() !== '') {
      try {
        const fn = new Function('product', 'variant', 'btn', 'detail', customJs);
        const res = fn(
          { id: productId, title: productTitle },
          { id: variantId, title: variantTitle },
          btn,
          detail
        );
        if (res !== false) {
          dispatchWaitlistEvents(detail);
          return;
        }
      } catch (err) {
        console.warn('[Waitlist] Custom JS execution failed:', err);
      }
    }

    // 2. Popup trigger link / Hash trigger (e.g. hoppy, hoppy-8b5d12af-..., #Ecomsend_popups_open_...)
    if (popupLink && popupLink.trim() !== '') {
      const trimmedLink = popupLink.trim();

      // 2a. Hoppy Popups trigger (e.g. hoppy-8b5d12af-..., 8b5d12af-..., or 'hoppy')
      if (isHoppyTrigger(trimmedLink)) {
        const hoppyId = extractHoppyId(trimmedLink);
        if (triggerHoppyPopup(hoppyId, productId)) {
          dispatchWaitlistEvents(detail);
          return;
        }
        // Retry polling in case Hoppy script is loading asynchronously
        var attempts = 0;
        var timer = setInterval(function () {
          attempts++;
          if (triggerHoppyPopup(hoppyId, productId) || attempts >= 20) {
            clearInterval(timer);
          }
        }, 100);
        dispatchWaitlistEvents(detail);
        return;
      }

      // 2b. Standard hash trigger (e.g. #Ecomsend_popups_open_... or #sendwill-popup)
      if (trimmedLink.startsWith('#')) {
        // 2a. Check if an element matching this ID exists and can be opened
        const targetEl = document.querySelector(trimmedLink);
        if (targetEl && targetEl !== btn) {
          if (typeof targetEl.showModal === 'function') {
            targetEl.showModal();
            dispatchWaitlistEvents(detail);
            return;
          }
          if (typeof targetEl.open === 'function') {
            targetEl.open();
            dispatchWaitlistEvents(detail);
            return;
          }
          if (typeof targetEl.show === 'function') {
            targetEl.show();
            dispatchWaitlistEvents(detail);
            return;
          }
        }

        // 2b. If EcomSend popup trigger
        if (trimmedLink.toLowerCase().includes('ecomsend')) {
          const ecomsendId = trimmedLink.replace(/.*Ecomsend_popups_open_/i, '').replace(/^#/, '').trim();

          if (typeof window.CwillSendwill?.openPopup === 'function') {
            try { window.CwillSendwill.openPopup(ecomsendId); } catch (e) {}
          }
          if (typeof window.Sendwill?.open === 'function') {
            try { window.Sendwill.open(ecomsendId); } catch (e) {}
          }
          if (typeof window.EcomSend?.open === 'function') {
            try { window.EcomSend.open(ecomsendId); } catch (e) {}
          }
          if (typeof window.Ecomsend?.openPopup === 'function') {
            try { window.Ecomsend.openPopup(ecomsendId); } catch (e) {}
          }

          try {
            if (window.location.hash !== trimmedLink) {
              window.location.hash = trimmedLink;
            }
            window.dispatchEvent(new HashChangeEvent('hashchange'));
          } catch (e) {}

          const virtualLink = document.createElement('a');
          virtualLink.href = trimmedLink;
          virtualLink.style.position = 'fixed';
          virtualLink.style.top = '-9999px';
          virtualLink.style.left = '-9999px';
          virtualLink.style.opacity = '0';
          document.body.appendChild(virtualLink);
          virtualLink.click();
          setTimeout(() => virtualLink.remove(), 1000);

          dispatchWaitlistEvents(detail);
          return;
        }

        // 2c. Other hash triggers
        const virtualLink = document.createElement('a');
        virtualLink.href = trimmedLink;
        virtualLink.style.display = 'none';
        document.body.appendChild(virtualLink);
        virtualLink.click();
        virtualLink.remove();

        try {
          if (window.location.hash !== trimmedLink) {
            window.location.hash = trimmedLink;
          }
          window.dispatchEvent(new HashChangeEvent('hashchange'));
        } catch (e) {}

        dispatchWaitlistEvents(detail);
        return;
      } else {
        // Selector trigger (e.g. .globo-form-open or [data-popup])
        try {
          const target = document.querySelector(trimmedLink);
          if (target && target !== btn) {
            if (typeof target.showModal === 'function') {
              target.showModal();
            } else if (typeof target.open === 'function') {
              target.open();
            } else if (typeof target.show === 'function') {
              target.show();
            } else {
              target.click();
            }
            dispatchWaitlistEvents(detail);
            return;
          }
        } catch (err) {
          console.warn('[Waitlist] Selector trigger failed:', trimmedLink, err);
        }
      }
    }

    // 3. Theme/App Modal ID trigger (if configured)
    if (modalId && modalId.trim() !== '') {
      const modal = document.getElementById(modalId);
      if (modal) {
        if (typeof modal.show === 'function') {
          modal.show();
          dispatchWaitlistEvents(detail);
          return;
        }
        if (typeof modal.open === 'function') {
          modal.open();
          dispatchWaitlistEvents(detail);
          return;
        }
        if (typeof modal.showModal === 'function') {
          modal.showModal();
          dispatchWaitlistEvents(detail);
          return;
        }
        const opener = document.querySelector(`[aria-controls="${modalId}"]`);
        if (opener && opener !== btn) {
          opener.click();
          dispatchWaitlistEvents(detail);
          return;
        }
        modal.removeAttribute('hidden');
        modal.classList.add('is-open', 'active');
        dispatchWaitlistEvents(detail);
        return;
      }
    }

    // 4. Auto-detect installed Back-in-Stock / Subscription plugins:
    // 4a. EcomSend / CwillSendwill / Sendwill Popup Email app
    const sendwillTrigger = document.querySelector(
      '.cw-popup-trigger, [data-sendwill-trigger], .cwill-popup, .sendwill-popup-btn, [data-cw-popup], a[href*="Ecomsend_popups_open"]'
    );
    if (sendwillTrigger && sendwillTrigger !== btn) {
      sendwillTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }
    if (window.CwillSendwill?.openPopup || window.Sendwill?.open || window.EcomSend?.open) {
      (window.CwillSendwill?.openPopup || window.Sendwill?.open || window.EcomSend?.open)();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4b. Powerful Form Builder / Globo Form Builder
    const globoTrigger = document.querySelector(
      '.globo-form-open, .gfb-open-modal, [data-globo-form-id], .globo-form-app [data-id]'
    );
    if (globoTrigger && globoTrigger !== btn) {
      globoTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }
    if (window.GloboFormBuilder?.openModal) {
      window.GloboFormBuilder.openModal();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4c. Shopify Forms app
    const formsTrigger = document.querySelector(
      '[data-forms-open], .shopify-forms-button, [aria-controls^="shopify-forms"]'
    );
    if (formsTrigger && formsTrigger !== btn) {
      formsTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }
    if (window.Shopify?.forms?.open) {
      window.Shopify.forms.open();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4d. Brevo / PushOwl BIS
    if (window.pushowl?.triggerBackInStock) {
      window.pushowl.triggerBackInStock({ variantId: variantId ? Number(variantId) : undefined });
      dispatchWaitlistEvents(detail);
      return;
    }
    const pushowlTrigger = document.querySelector('.pushowl-widget, .pushowl-bis-btn, .pushowl-trigger');
    if (pushowlTrigger && pushowlTrigger !== btn) {
      pushowlTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4e. Klaviyo Back in Stock / Form
    if (window._klOnsite) {
      try {
        window._klOnsite.push(['openForm']);
      } catch (e) {}
    }
    const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger, .klaviyo-custom-trigger');
    if (klaviyoTrigger && klaviyoTrigger !== btn) {
      klaviyoTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4f. Swym / Restock Rocket / Vitals / Other BIS plugins
    const otherBisTrigger = document.querySelector(
      '.swym-button, .swym-add-to-watchlist, .vitals-restock-btn, [data-vitals-app="restock"], .bis-trigger, .restock-rocket-btn, .notify-me-btn, [data-bis-trigger], .back-in-stock-btn, [data-restock-trigger]'
    );
    if (otherBisTrigger && otherBisTrigger !== btn) {
      otherBisTrigger.click();
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4g. Hoppy Popups / FutureBlink Email Popups auto-detect (prioritize before theme newsletter modal)
    if (hasHoppyOnPage()) {
      if (triggerHoppyPopup('', productId)) {
        dispatchWaitlistEvents(detail);
        return;
      }
      var attemptsAuto = 0;
      var timerAuto = setInterval(function () {
        attemptsAuto++;
        if (triggerHoppyPopup('', productId) || attemptsAuto >= 30) {
          clearInterval(timerAuto);
        }
      }, 100);
      dispatchWaitlistEvents(detail);
      return;
    }

    // 4h. Theme subscription popup fallback (ONLY when no back-in-stock plugin exists)
    const themePopup = document.querySelector('subscription-popup, [id^="SubscriptionModal-"]');
    if (themePopup) {
      if (typeof themePopup.show === 'function') {
        themePopup.show();
        dispatchWaitlistEvents(detail);
        return;
      }
      if (typeof themePopup.open === 'function') {
        themePopup.open();
        dispatchWaitlistEvents(detail);
        return;
      }
      const themePopupOpener = document.querySelector('[aria-controls="' + themePopup.id + '"]');
      if (themePopupOpener && themePopupOpener !== btn) {
        themePopupOpener.click();
        dispatchWaitlistEvents(detail);
        return;
      }
      themePopup.removeAttribute('hidden');
      themePopup.classList.add('is-open');
      dispatchWaitlistEvents(detail);
      return;
    }

    // 5. Final fallback: dispatch CustomEvents so any registered script catches it
    dispatchWaitlistEvents(detail);
  };

  function dispatchWaitlistEvents(detail) {
    document.dispatchEvent(new CustomEvent('waitlist:open', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('open:waitlist-popup', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('shopify:forms:open', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('bis:open', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('theme:waitlist:clicked', { bubbles: true, detail }));
  }

  // Delegated click listener for all waitlist buttons
  document.addEventListener(
    'click',
    function (event) {
      const waitlistBtn = event.target.closest(
        '[data-waitlist-trigger="true"], .btn--waitlist, [data-waitlist-trigger], .product-form__waitlist-btn, .product-waitlist__trigger'
      );
      if (!waitlistBtn) return;

      event.preventDefault();
      event.stopPropagation();
      window.triggerWaitlistPopup(waitlistBtn);
    },
    true
  );
})();
